import { SubAPI } from "./SubAPI";
export class QuoteMiscProducts extends SubAPI {
    list(input) { return this.fetcher.get("/api/quote-misc-products", input); }
    upsert(input) { return this.fetcher.post("/api/quote-misc-product", input); }
}
